import { Component } from "react";
import { JJ_Icon_Chevron_right, JJ_Icon_Chevron_down } from "../../assets";
import config from "../../config/config";
import trackingService from "../../services/trackingService";
import "../ContentShortcuts/ContentShortcuts.css";


class TAamdDiseasesGenAIRec extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCSModal: false,
      products: props.products,
      arrayOfDocTypes: [],
      showInfo: false,
      startIndex: 0,
      showContentImmunology: false,
      showContentCNS: false,
      showContentCVM: false,
      showContentOnCology: false,
      showContentID: false,
      showTADashboard: false,
    };
  }

  async componentDidMount() {
    this.setState({
      arrayOfDocTypes: config.tadProducts,
    });
  }

  componentDidUpdate = () => {
    if (this.props.showSCDCSModal !== this.state.showCSModal) {
      this.setState({ showCSModal: this.props.showSCDCSModal });
    }
  };


  generateListOfDocTypes = (arrayOfDoc, item) => {
    if (arrayOfDoc.length > 0) {
      return arrayOfDoc.map((items, index) => {
        let url;
        url = items.filter;
        if (items.property === "parentLink")
          return (
            <div className="gen-ai-ims-home-modal-list-genAI-main-div">
              <li key={index} className="modal-list-genAI">
                <a href={url} target="_blank" rel="noreferrer" className="cs-modalLink">
                  <span className="gen-ai-ims-home-modal-list-title">{items.title}</span>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.6665 8H13.3328M13.3328 8L9.33294 4M13.3328 8L9.33294 12" stroke="#EB1700" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </a>
              </li>
            </div>
          );
        else {
          return (
            <div className="gen-ai-ims-home-modal-list-genAI-main-div">
              <li key={index} className="modal-list-genAI">
                <a href={url} target="_blank" rel="noreferrer" className="cs-modalLink">
                  <span className="gen-ai-ims-home-modal-list-title">{items.title}</span>
                  <svg width= {item === "Oncology" ? "30px" : "16px"} height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.6665 8H13.3328M13.3328 8L9.33294 4M13.3328 8L9.33294 12" stroke="#EB1700" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </a>
              </li>
            </div>
          );
        }
      });
    }
  };

  handelDocsTypesLinks = (filter, title) => {
    const ts = new trackingService();
    ts.indexTrackingData(
      localStorage.getItem("userdisplayName"),
      localStorage.getItem("wwid"),
      localStorage.getItem("username"),
      localStorage.getItem("function"),
      localStorage.getItem("region"),
      localStorage.getItem("userproducts"),
      localStorage.getItem("doctypepref"),
      localStorage.getItem("sid"),
      localStorage.getItem("deviceType"),
      localStorage.getItem("deviceOS"),
      localStorage.getItem("browserName"),
      localStorage.getItem("browserVersion"),
      localStorage.getItem("jnjDepartment"),
      localStorage.getItem("companyname"),
      // "Link visited from Scientific Communication Documents tile",
      "",
      window.location.href,
      filter,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      `Scientific Communication Documents-${title}`,
    );
  };

  toggleExpandSectionImmunology = () => {
    this.setState({
      showContentImmunology: !this.state.showContentImmunology,
      showContentCNS: false,
      showContentCVM: false,
      showContentOnCology: false,
      showContentID: false,
      showTADashboard: false,
    })
  }

  toggleExpandSectioncns = () => {
    this.setState({
      showContentCNS: !this.state.showContentCNS,
      showContentImmunology: false,
      showContentCVM: false,
      showContentOnCology: false,
      showContentID: false,
      showTADashboard: false,
    })
  }

  toggleExpandSectioncvm = () => {
    this.setState({
      showContentCVM: !this.state.showContentCVM,
      showContentImmunology: false,
      showContentCNS: false,
      showContentOnCology: false,
      showContentID: false,
      showTADashboard: false,
    })
  }

  toggleExpandSectiononcology = () => {
    this.setState({
      showContentOnCology: !this.state.showContentOnCology,
      showContentImmunology: false,
      showContentCNS: false,
      showContentCVM: false,
      showContentID: false,
      showTADashboard: false,
    })
  }

  toggleExpandSectionID = () => {
    this.setState({
      showContentID: !this.state.showContentID,
      showContentImmunology: false,
      showContentCNS: false,
      showContentCVM: false,
      showContentOnCology: false,
      showTADashboard: false,
    })
  }

  toggleExpandTADashboard = () => {
    this.setState({
      showTADashboard: !this.state.showTADashboard,
      showContentImmunology: false,
      showContentCNS: false,
      showContentCVM: false,
      showContentOnCology: false,
      showContentID: false
    })
  }

  handleCloseModal = () => {
    this.setState({ showCSModal: false }, () => {
      this.props.handelTADCardDetail(this.state.showCSModal);
    });
  };

  render() {
    return (
      <div className="GenAI-Recomm-ContentShortcutInnerWapper-tad">
        <div className="gen-ai-ims-home-contentshortcut-cancel-btn popoverAvoidClickOutside">
          <span className="popoverAvoidClickOutside" onClick={this.handleCloseModal}>
            <svg width="18px" height="18px" className="popoverAvoidClickOutside" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <title>cancel</title> <g id="Page-1" stroke-width="0.00512" fill="none" fill-rule="evenodd">
                <g id="work-case" fill="#afa7a7" transform="translate(91.520000, 91.520000)">
                  <polygon id="Close" points="328.96 30.2933333 298.666667 1.42108547e-14 164.48 134.4 30.2933333 1.42108547e-14 1.42108547e-14 30.2933333 134.4 164.48 1.42108547e-14 298.666667 30.2933333 328.96 164.48 194.56 298.666667 328.96 328.96 298.666667 194.56 164.48"> </polygon>
                </g>
              </g>
              </g>
            </svg>
          </span>
        </div>
        <div className="gen-ai-ims-home-contentshortcut-div">
          <div className="gen-ai-ims-home-contentshortcut-inside-div-add-scroll">
            <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem">
              <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem-inside-div">
                <span className="gen-ai-ims-home-contentshortcut-div-inside-span">CNS</span>
                {this.state.showContentCNS ? <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandSectioncns} src={JJ_Icon_Chevron_down} alt="Loading Data" /> :
                  <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandSectioncns} src={JJ_Icon_Chevron_right} alt="Loading Data" />
                }
              </div>
            </div>
            {this.state.showContentCNS && <>
              <div className="gen-ai-ims-home-modal-body-height-genAI">
                <div className="cs-modalList gen-ai-cs-modalList">
                  <ul style={{ listStyle: "none" }}>
                    {this.generateListOfDocTypes(config.tadProducts[0].CNS)}
                  </ul>
                </div>
              </div>
            </>}
            <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem">
              <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem-inside-div">
                <span className="gen-ai-ims-home-contentshortcut-div-inside-span">Immunology</span>
                {this.state.showContentImmunology ? <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandSectionImmunology} src={JJ_Icon_Chevron_down} alt="Loading Data" /> :
                  <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandSectionImmunology} src={JJ_Icon_Chevron_right} alt="Loading Data" />
                }
              </div>
            </div>
            {this.state.showContentImmunology && <>
              <div className="gen-ai-ims-home-modal-body-height-genAI">
                <div className="cs-modalList gen-ai-cs-modalList">
                  <ul style={{ listStyle: "none" }}>
                    {this.generateListOfDocTypes(config.tadProducts[1].Immunology)}
                  </ul>
                </div>
              </div>
            </>}
            <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem">
              <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem-inside-div">
                <span className="gen-ai-ims-home-contentshortcut-div-inside-span">CVM</span>
                {this.state.showContentCVM ? <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandSectioncvm} src={JJ_Icon_Chevron_down} alt="Loading Data" /> :
                  <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandSectioncvm} src={JJ_Icon_Chevron_right} alt="Loading Data" />
                }
              </div>
            </div>
            {this.state.showContentCVM && <>
              <div className="gen-ai-ims-home-modal-body-height-genAI">
                <div className="cs-modalList gen-ai-cs-modalList">
                  <ul style={{ listStyle: "none" }}>
                    {this.generateListOfDocTypes(config.tadProducts[2].CVM)}
                  </ul>
                </div>
              </div>
            </>}
            <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem">
              <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem-inside-div">
                <span className="gen-ai-ims-home-contentshortcut-div-inside-span">Oncology</span>
                {this.state.showContentOnCology ? <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandSectiononcology} src={JJ_Icon_Chevron_down} alt="Loading Data" /> :
                  <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandSectiononcology} src={JJ_Icon_Chevron_right} alt="Loading Data" />
                }
              </div>
            </div>
            {this.state.showContentOnCology && <>
              <div className="gen-ai-ims-home-modal-body-height-genAI-oncology">
                <div className="cs-modalList gen-ai-cs-modalList">
                  <ul style={{ listStyle: "none" }}>
                    {this.generateListOfDocTypes(config.tadProducts[3].Oncology, 'Oncology')}
                  </ul>
                </div>
              </div>
            </>}
            <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem">
              <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem-inside-div">
                <span className="gen-ai-ims-home-contentshortcut-div-inside-span">Infectious Disease</span>
                {this.state.showContentID ? <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandSectionID} src={JJ_Icon_Chevron_down} alt="Loading Data" /> :
                  <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandSectionID} src={JJ_Icon_Chevron_right} alt="Loading Data" />
                }
              </div>
            </div>
            {this.state.showContentID && <>
              <div className="gen-ai-ims-home-modal-body-height-genAI">
                <div className="cs-modalList gen-ai-cs-modalList">
                  <ul style={{ listStyle: "none" }}>
                    {this.generateListOfDocTypes(config.tadProducts[4]["Infectious Disease"])}
                  </ul>
                </div>
              </div>
            </>}
            <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem">
              <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem-inside-div">
                <span className="gen-ai-ims-home-contentshortcut-div-inside-span">TA Dashboards</span>
                {this.state.showTADashboard ? <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandTADashboard} src={JJ_Icon_Chevron_down} alt="Loading Data" /> :
                  <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandTADashboard} src={JJ_Icon_Chevron_right} alt="Loading Data" />
                }
              </div>
            </div>
            {this.state.showTADashboard && <>
              <div className="gen-ai-ims-home-modal-body-height-genAI">
                <div className="cs-modalList gen-ai-cs-modalList">
                  <ul style={{ listStyle: "none" }}>
                    {this.generateListOfDocTypes(config.tadProducts[5]["TA Dashboards"])}
                  </ul>
                </div>
              </div>
            </>}
          </div>
        </div>
      </div>
    );
  }
}

export default TAamdDiseasesGenAIRec;
